/* @ngInject */
export default function PTZControlsService($sails, $q, $log) {
  const service = this;

  service.getIdleTimeout = getIdleTimeout;
  service.moveInDirection = moveInDirection;
  service.setHome = setHome;
  service.setHomeTimeout = setHomeTimeout;
  service.getPTZCapabilities = getPTZCapabilities;
  service.getPTZInfo = getPTZInfo;
  service.getPTZLimits = getPTZLimits;
  service.alterPTZ = alterPTZ;
  service.absolutePositionPTZ = absolutePositionPTZ;
  service.relativePositionPTZ = relativePositionPTZ;

  function getIdleTimeout(equipmentId) {
    return $sails.get(`/equipment/${equipmentId}/statuses/getPtzIdleTimeout`)
      .then((success) => {
        let timeoutDuration = 0;
        if (success.data && success.data.timeout) {
          timeoutDuration = success.data.timeout;
        }
        return timeoutDuration;
      })
      .catch(logError);
  }

  function moveInDirection(equipmentId, direction, view) {
    return $sails.post(`/equipment/${equipmentId}/actions/ptz`, {
      id: equipmentId,
      direction,
      camera: view
    })
      .catch(logError);
  }

  function setHome(equipmentId) {
    return $sails.post(`/equipment/${equipmentId}/actions/setPtzHome`, {
      id: equipmentId
    })
      .catch(logError);
  }

  function setHomeTimeout(equipmentId, timeoutDuration) {
    return $sails.post(`/equipment/${equipmentId}/actions/setPtzIdleTimeout`, {
      id: equipmentId,
      timeout: timeoutDuration
    })
      .catch(logError);
  }

  function getPTZCapabilities(camId) {
    return $sails.get(`/equipment/${camId}/statuses/getPtzCapable`)
      .then(({ data }) => data.ptz === 'yes' && data.digitalPtz === 'no')
      .catch(logError);
  }

  function getPTZInfo(camId) {
    return $sails.get(`/equipment/${camId}/statuses/getPtzInfo`)
      .then(({ data }) => data)
      .catch(logError);
  }

  function getPTZLimits(camId) {
    return $sails.get(`/equipment/${camId}/statuses/getPtzLimits`)
      .then(({ data }) => data)
      .catch(logError);
  }

  function alterPTZ(camId, params) {
    params.id = camId;
    return $sails.post(`/equipment/${camId}/actions/ptz`, params)
      .catch(logError);
  }

  function absolutePositionPTZ(camId, coordinates) {
    coordinates.id = camId;
    return $sails.post(`/equipment/${camId}/actions/absolutePTZ`, coordinates)
      .catch(logError);
  }

  function relativePositionPTZ(camId, coordinates) {
    coordinates.id = camId;
    return $sails.post(`/equipment/${camId}/actions/relativePTZ`, coordinates)
      .catch(logError);
  }

  function logError(err) {
    $log.error('Error: ', err);
    return $q.reject(err.data);
  }
}
